

const activeNoActive    = require('../../js/active-noactive')
const appnav            = require ('../../components/appnav/appnav')
const appnavGenerator   = require ('../../components/appnav/appnav-generator')
const avatar            = require('../../components/avatar/avatar')
const backControl       = require ('../../js/back-control')
const drawer            = require ('../../components/drawer/drawer')
const online            = require('../../js-network/online')
//const page              = require ('../../components/page/page')
const pageMap 			  = require('./warehouse-page-map')
const websocket         = require ('../../js-network/web-socket')


import appbarHtml from "./appbar.html";
import avatarHtml from "./avatar.html";
import drawerHtml from "./drawer.html";
import appnavHtml from "./appnav.html";




export function start(settingsData){	//console.log('investorApp APP - START>>>>>>>>>>>>>>>>>>' )
	
	const body = document.body	

	//mobileView
	body.classList.add('body-mobile')

	//appbar
    body.insertAdjacentHTML("beforeend", appbarHtml)  

	//Avatar
	body.insertAdjacentHTML("beforeend", avatarHtml)  
	avatar.generator('avatar', settingsData)

	//drawer
	body.insertAdjacentHTML("beforeend", drawerHtml)  
	drawer.start({act:'generator', data:settingsData})

	//appnav
	body.insertAdjacentHTML("beforeend", appnavHtml)  


	// clockstart.start()
    // clockHtmlPage.start()


    //is the first time that you loging>showTutorial
    if( localStorage.getItem('appnav') === null){
    	//clockTools.showTutorial()
    }

	settingsData.pageMap = pageMap //remove this 
	appnav.showLast()




	//amenidies
	// websocket.init({act:"init"}) 
	// backControl.enable()
	// online.enable()
	// activeNoActive.enable()



}/**/



